import { useEffect, useState, startTransition } from 'react'
import { useQuery } from '@apollo/client'
import { getProjectQuery, Project, Episode, Season } from '@/services/ProjectsService'
import { normalizeProjectSeasons } from '@/services/ProjectsService/normalizeSeasons'
import { getProjectTheme } from '@/utils/project-themes'
import { ProjectTheme } from '@/utils/project-themes/types'
import { useWatchProjectData } from '@/views/WatchProjectView/useWatchProjectData'

interface UseWatchProjectProps {
  projectSlug: string
  skip?: boolean
}

export const useWatchProject = ({
  projectSlug,
  skip = false,
}: UseWatchProjectProps): {
  preferredSeason?: Season
  currentEpisode?: Episode
  project?: Project
  projectTheme: ProjectTheme
  loading: boolean
} => {
  const [project, setProject] = useState<Project>()

  const { data, loading } = useQuery(getProjectQuery, {
    variables: { slug: projectSlug, includePrerelease: true },
    errorPolicy: 'all',
  })

  const { currentEpisode, preferredSeason } = useWatchProjectData({ data: data?.project, skip })
  const projectTheme = getProjectTheme(projectSlug) ?? {}

  useEffect(() => {
    startTransition(() => {
      setProject(normalizeProjectSeasons(data?.project as Project | undefined))
    })
  }, [data])

  return {
    currentEpisode,
    preferredSeason,
    project,
    projectTheme,
    loading,
  }
}
